import { createContext } from "react";

import { IContextPostConstructorOpener } from "./post_constructor_opener.types";

export const ContextPostConstructorOpener =
  createContext<IContextPostConstructorOpener>(
    null as unknown as IContextPostConstructorOpener,
  );

ContextPostConstructorOpener.displayName = "ContextPostConstructorOpener";
